/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProgramDashboardDto } from './ProgramDashboardDto';
import {
    ProgramDashboardDtoFromJSON,
    ProgramDashboardDtoFromJSONTyped,
    ProgramDashboardDtoToJSON,
    ProgramDashboardDtoToJSONTyped,
} from './ProgramDashboardDto';

/**
 * 
 * @export
 * @interface ChildTenantPortfolioDto
 */
export interface ChildTenantPortfolioDto {
    /**
     * 
     * @type {string}
     * @memberof ChildTenantPortfolioDto
     */
    tenantId?: string;
    /**
     * 
     * @type {ProgramDashboardDto}
     * @memberof ChildTenantPortfolioDto
     */
    dashboard?: ProgramDashboardDto;
}

/**
 * Check if a given object implements the ChildTenantPortfolioDto interface.
 */
export function instanceOfChildTenantPortfolioDto(value: object): value is ChildTenantPortfolioDto {
    return true;
}

export function ChildTenantPortfolioDtoFromJSON(json: any): ChildTenantPortfolioDto {
    return ChildTenantPortfolioDtoFromJSONTyped(json, false);
}

export function ChildTenantPortfolioDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChildTenantPortfolioDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'dashboard': json['dashboard'] == null ? undefined : ProgramDashboardDtoFromJSON(json['dashboard']),
    };
}

export function ChildTenantPortfolioDtoToJSON(json: any): ChildTenantPortfolioDto {
    return ChildTenantPortfolioDtoToJSONTyped(json, false);
}

export function ChildTenantPortfolioDtoToJSONTyped(value?: ChildTenantPortfolioDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'dashboard': ProgramDashboardDtoToJSON(value['dashboard']),
    };
}

